export default __webpack_public_path__ + "static/media/banner-nohayeventosm.b4cd4271.jpg";